import PunnyCode from "./components/PunnyCode"
import WrapperLayout from 'components/Layout';
import DomainVariations from "./components/DomainVariations";
import DomainChecker from "./components/DomainChecker";
import SendCompanyNames from "./components/SendCompanyNames";
const DomainAnalysis = () => {
    return (
        <WrapperLayout>
        <PunnyCode/>
        <DomainVariations/>
        <DomainChecker/>
        <SendCompanyNames/>
        </WrapperLayout>
    )
}
export default DomainAnalysis